import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "clockqrwrap"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_qrcodesection = _resolveComponent("qrcodesection");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_qrcodesection, {
    url: $data.url,
    width: 200,
    height: 200
  }, null, 8, ["url"])]);
}